//
// This module store global configuration and data for the kiosk,
// that don't requires their own module / reducer
//
export * from './actions'
export * from './middlewares'
export * from './selectors'
